var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footercommon"},[_c('b-row',_vm._l((_vm.columns),function(col){return _c('b-col',{key:col,staticClass:"footercommon-col",attrs:{"cols":_vm.scss.vars['mobile-breakpoint-down']}},[_vm._t(col)],2)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }